import React from "react"
//import { Link } from "gatsby"
import {graphql, StaticQuery, Link} from 'gatsby'
//import './Teams.css';


const Historikk = () => (
    <StaticQuery query={graphql`
        {
            allWordpressWpHistorikk(sort: {order: ASC, fields: date}) {
                edges {
                    node {
                        id
                        title
                        content
                        wordpress_id
                        excerpt
                        slug
                    }
                }
            }
        }
    `} render={props => (
      <div className="row">
      
        {props.allWordpressWpHistorikk.edges.map(post => (
          <div id={post.node.wordpress_id} key={post.node.id}>
              <div className="card card-body">                             
                <h2 className="text-primary text-center">{post.node.title}</h2>                   
                <div className="card-body">
                  <div dangerouslySetInnerHTML={{__html: post.node.excerpt}}></div>
                  <Link to={`/historikk/${post.node.slug}`}>Les mer</Link>
                </div>  
              </div> 
          </div>
        ))}
      </div>
    )} />
)

export default Historikk;